<script setup lang="ts">
import { infiniteScrollingHelper } from '../../webcomponents/src/infiniscroll'
import { make_shuffler } from '../../webcomponents/src/pluralistic'
import type { Post } from '~~/prisma/generated/client'
const shuffler = make_shuffler()

const props = defineProps(
  {
    api: { type: String, required: true },
    pluralistic: { type: Boolean, default: false },
    offsetPagination: { type: Boolean, default: false }
  })

const { data: initialPosts = [] } = await useFetch<Post[]>(props.api)
const posts = ref([...(unref(initialPosts) ?? [])])

function onPostUpdated(updatedPost: Post & { tags: string[] }) {
  const index = unref(posts).findIndex( (p: Post) => p.id === updatedPost.id)
  const post = posts.value[index] as Post
  post.title = updatedPost.title
  post.summary = updatedPost.summary
  post.tags = updatedPost.tags
  post.visible = updatedPost.visible
  post.pinned = updatedPost.pinned
}

function onPostRemoved(post: Post) {
  const index = posts.value.findIndex((p: Post) => p.id === post.id)
  console.log("remove", index)
  if (index != -1) {
    posts.value.splice(index, 1)
  }
}

const loading = ref(false)
const shouldFetchAgain = ref<boolean>(true)
const infiniteScrolling = async ({isIntersecting} : {isIntersecting: boolean}) => {
  if(!isIntersecting) {  // we don't care unless we're at the end
    return
  }
  if(!shouldFetchAgain.value) { // this means we've already hit the end
    return
  }
  loading.value = true
  const foundSomething = await infiniteScrollingHelper(
    posts, props.api, props.offsetPagination ? "offset" : "cursor",
    props.pluralistic, shuffler)
  shouldFetchAgain.value = foundSomething
  loading.value = false
}
</script>

<template>
  <PostList
    :posts="posts"
    :loading="loading"
    @post-updated="onPostUpdated"
    @post-removed="onPostRemoved"
    @loadMore="infiniteScrolling"
  />
</template>
